import Telemetry from '@atlassian/mpac-telemetry';
import { useHistory, useLocation } from '@atlassian/mpac-ui';
import { useEffect } from 'react';

type Props = {
  getRouteName: (pathname: string, search?: string) => string | null | undefined;
};

function TelemetryNavigationListener({ getRouteName }: Props) {
  const { pathname, search } = useLocation();
  const routeName = getRouteName(pathname || '', search) || 'unknown';
  const fullPath = (pathname || '') + (search || '');
  Telemetry.setPage(routeName, fullPath);
  const history = useHistory();
  // Trace page load event for all routes
  useEffect(() => {
    // Trace Page load on initial load
    Telemetry.traceUFOPageLoad(routeName);
    // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
    history.listen((location) => {
      const pageName = getRouteName(location.pathname || '', location.search) || 'unknown';
      const locationFullPath = (location.pathname || '') + (location.search || '');
      Telemetry.setPage(pageName, locationFullPath);
      // Trace page transition
      Telemetry.traceUFOPageLoad(pageName);
    });
  }, []);
  return null;
}

export default TelemetryNavigationListener;
